import { toastService } from '@app/services/toastService';
import { CustomError, validationErrorTypeGuard } from '@app/types';

export const handleApiError = (err: any, title?: string) => {
  if (validationErrorTypeGuard(err)) {
    const content = err.data.data.errors
      .map((error) => Object.values(error.constraints).join(', '))
      .join('; ');

    return toastService.error({
      title: err.data.message,
      content,
    });
  }

  const error = err as CustomError;
  return toastService.error({
    title: title || error.data.error,
    content: error.data.message,
  });
};
